/**
 * @flow
 * @relayHash 728770f7bf0e816e1c0fd2f4a7167162
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateWidgetEnabledInput = {
  userId: string,
  widgetId: string,
  enabled: boolean,
  clientMutationId?: ?string,
};
export type UpdateWidgetEnabledMutationVariables = {|
  input: UpdateWidgetEnabledInput
|};
export type UpdateWidgetEnabledMutationResponse = {|
  +updateWidgetEnabled: ?{|
    +widget: ?{|
      +enabled: ?boolean
    |}
  |}
|};
export type UpdateWidgetEnabledMutation = {|
  variables: UpdateWidgetEnabledMutationVariables,
  response: UpdateWidgetEnabledMutationResponse,
|};
*/


/*
mutation UpdateWidgetEnabledMutation(
  $input: UpdateWidgetEnabledInput!
) {
  updateWidgetEnabled(input: $input) {
    widget {
      enabled
      id
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateWidgetEnabledInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input",
    "type": "UpdateWidgetEnabledInput!"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "enabled",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "UpdateWidgetEnabledMutation",
  "id": null,
  "text": "mutation UpdateWidgetEnabledMutation(\n  $input: UpdateWidgetEnabledInput!\n) {\n  updateWidgetEnabled(input: $input) {\n    widget {\n      enabled\n      id\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateWidgetEnabledMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetEnabled",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetEnabledPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widget",
            "storageKey": null,
            "args": null,
            "concreteType": "Widget",
            "plural": false,
            "selections": [
              v2
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateWidgetEnabledMutation",
    "argumentDefinitions": v0,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "updateWidgetEnabled",
        "storageKey": null,
        "args": v1,
        "concreteType": "UpdateWidgetEnabledPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "widget",
            "storageKey": null,
            "args": null,
            "concreteType": "Widget",
            "plural": false,
            "selections": [
              v2,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f6726e995666d8c93f03c5f31caa0e72';
module.exports = node;



// WEBPACK FOOTER //
// ./src/js/mutations/__generated__/UpdateWidgetEnabledMutation.graphql.js